import React from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import PayMethods from './Components/PayMethods';
import FailedPayments from './Components/FailedPayments';
import theme from 'theme';
import MicrodepositsEntry from './Components/MicrodepositsEntry';
import InvoiceDownload from './Components/business/InvoiceDownload';
import PaymentLocationQRCodes from './Components/PaymentLocationQRCodes';
import PaymentFaq from './Components/PaymentFaq';

interface BusinessPaymentProps {}

export default function BusinessPayments({}: BusinessPaymentProps) {
    const mdUp = useMediaQuery(theme.breakpoints.up('md'));
    return (
        <Grid container justify="center">
            <Grid container item direction="row" lg={10} md={12} sm={9} xs={12}>
                <Grid item direction="column" lg={6} md={6} sm={9} xs={12} style={{ paddingRight: mdUp ? 20 : 0 }}>
                    <Grid item>
                        <MicrodepositsEntry />
                        <FailedPayments />
                        <PayMethods />
                        <PaymentFaq />
                    </Grid>
                </Grid>
                <Grid item direction="column" lg={6} md={6} sm={9} xs={12} alignContent="flex-start">
                    <Grid item xs={12}>
                        <InvoiceDownload />
                        <PaymentLocationQRCodes />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
